import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.miniStressLastSendNotificationTime.loading;
export const selectErrorMessage = (state: RootState) =>
  state.miniStressLastSendNotificationTime.error;
export const miniStressLastSendNotificationTimeResponse = (state: RootState) =>
  state.miniStressLastSendNotificationTime
    .miniStressLastSendNotificationTimeResponse;
